import { WorkOrder } from '../types/workOrder';

export const mockWorkOrders: any[] = [
  {
    id: '1',
    woNumber: 'WO/2025-26/HYD/0042',
    title: 'Core & Shell -- Tower B',
    description: 'Complete core and shell work for Tower B including structural, mechanical, and electrical components',
    site: 'HYD/TWR-B',
    project: 'Hyderabad Tower Complex',
    organisation: 'Galaxy Infra',
    contractType: 'Fixed Price',
    contractorName: 'Galaxy Infrastructure Pvt Ltd',
    status: 'Pending',
    woValue: 2237280,
    dateReleased: '2025-08-07',
    plannedStartDate: '2025-08-15',
    plannedEndDate: '2025-12-15',
    contractDate: '2025-08-05',
    contractOwner: 'John Smith',
    approvalsDone: ['Technical Approval', 'Financial Approval'],
    linkedWorkRequest: 'WR/2025/HYD/001',
    linkedTender: 'TND/2025/HYD/042',
    workOrderLines: [
      {
        lineId: 'WOL-001',
        taskName: 'Foundation Digging',
        workCategory: 'Excavation',
        quantity: 500,
        uom: 'Cum',
        rate: 200,
        tax: 18,
        total: 118000
      },
      {
        lineId: 'WOL-002',
        taskName: 'Masonry',
        workCategory: 'Brick Work',
        quantity: 800,
        uom: 'Sqft',
        rate: 120,
        tax: 18,
        total: 113280
      }
    ],
    generalConditions: [
      'All materials to be as per specifications',
      'Work to be completed within scheduled timeframe',
      'Safety protocols to be strictly followed',
      'Quality inspections at each milestone'
    ],
    paymentConditions: {
      mobilizationAdvance: {
        percentage: 10,
        amount: 223728
      },
      retentionAmount: {
        percentage: 5,
        releaseDate: '2026-01-06'
      },
      onHoldAmount: {
        amount: 50000,
        releaseDate: '2026-06-30'
      },
      payOnCompletion: false
    },
    attachments: [
      {
        id: 'att1',
        fileName: 'Technical_Specifications.pdf',
        fileType: 'PDF',
        fileUrl: '/documents/tech_spec_042.pdf',
        uploadDate: '2025-08-07'
      },
      {
        id: 'att2',
        fileName: 'Site_Drawings.dwg',
        fileType: 'DWG',
        fileUrl: '/documents/drawings_042.dwg',
        uploadDate: '2025-08-07'
      }
    ],
    contractorActions: [],
    slaAge: 3,
    remarks: 'Awaiting review'
  },
  {
    id: '2',
    woNumber: 'WO/2025-26/HYD/0043',
    title: 'Podium Finishes',
    description: 'Interior and exterior finishing work for podium area including flooring, painting, and fixtures',
    site: 'HYD/TWR-A',
    project: 'Hyderabad Tower Complex',
    organisation: 'Alpha Constructions',
    contractType: 'Time & Material',
    contractorName: 'Alpha Construction Solutions',
    status: 'Under Negotiation',
    woValue: 1120000,
    dateReleased: '2025-08-06',
    plannedStartDate: '2025-08-20',
    plannedEndDate: '2025-11-20',
    contractDate: '2025-08-04',
    contractOwner: 'Sarah Johnson',
    approvalsDone: ['Technical Approval', 'Safety Approval'],
    linkedWorkRequest: 'WR/2025/HYD/002',
    workOrderLines: [
      {
        lineId: 'WOL-003',
        taskName: 'Floor Tiling',
        workCategory: 'Flooring',
        quantity: 1200,
        uom: 'Sqft',
        rate: 150,
        tax: 18,
        total: 212400
      },
      {
        lineId: 'WOL-004',
        taskName: 'Wall Painting',
        workCategory: 'Painting',
        quantity: 2000,
        uom: 'Sqft',
        rate: 80,
        tax: 18,
        total: 188800
      }
    ],
    generalConditions: [
      'Premium quality materials only',
      'Color schemes as per approved samples',
      'Clean up after each phase'
    ],
    paymentConditions: {
      mobilizationAdvance: {
        percentage: 15,
        amount: 168000
      },
      retentionAmount: {
        percentage: 5,
        releaseDate: '2026-02-20'
      },
      onHoldAmount: {
        amount: 25000,
        releaseDate: '2026-05-20'
      },
      payOnCompletion: true
    },
    attachments: [
      {
        id: 'att3',
        fileName: 'Finish_Schedule.pdf',
        fileType: 'PDF',
        fileUrl: '/documents/finish_schedule_043.pdf',
        uploadDate: '2025-08-06'
      }
    ],
    contractorActions: [
      {
        actionType: 'request_changes',
        timestamp: '2025-08-07T10:30:00Z',
        authorizedPersonName: 'Raj Patel',
        comments: 'Request scope change for premium marble flooring instead of ceramic tiles',
        reason: 'Client preference change'
      }
    ],
    lastContractorAction: 'Requested scope change',
    responseDate: '2025-08-07',
    slaAge: 1,
    remarks: 'Need internal review',
    changeHistory: [
      {
        version: 1,
        changes: 'Initial work order created',
        modifiedBy: 'Sarah Johnson',
        modifiedDate: '2025-08-06'
      },
      {
        version: 2,
        changes: 'Scope change request received',
        modifiedBy: 'System',
        modifiedDate: '2025-08-07'
      }
    ]
  },
  {
    id: '3',
    woNumber: 'WO/2025-26/HYD/0044',
    title: 'External Paving',
    description: 'Paving work for external areas including parking lots, walkways, and landscaping areas',
    site: 'HYD/EXT',
    project: 'Hyderabad Tower Complex',
    organisation: 'BuildRight',
    contractType: 'Fixed Price',
    contractorName: 'BuildRight Solutions Ltd',
    status: 'Accepted',
    woValue: 850000,
    dateReleased: '2025-08-05',
    plannedStartDate: '2025-08-12',
    plannedEndDate: '2025-10-12',
    contractDate: '2025-08-03',
    contractOwner: 'Mike Wilson',
    approvalsDone: ['Technical Approval', 'Financial Approval', 'Environmental Clearance'],
    linkedWorkRequest: 'WR/2025/HYD/003',
    workOrderLines: [
      {
        lineId: 'WOL-005',
        taskName: 'Concrete Paving',
        workCategory: 'Paving',
        quantity: 2500,
        uom: 'Sqft',
        rate: 180,
        tax: 18,
        total: 531000
      },
      {
        lineId: 'WOL-006',
        taskName: 'Interlocking Tiles',
        workCategory: 'Paving',
        quantity: 1000,
        uom: 'Sqft',
        rate: 250,
        tax: 18,
        total: 295000
      }
    ],
    generalConditions: [
      'Weather dependent work schedule',
      'Ensure proper drainage',
      'Use approved paving materials only'
    ],
    paymentConditions: {
      mobilizationAdvance: {
        percentage: 10,
        amount: 85000
      },
      retentionAmount: {
        percentage: 5,
        releaseDate: '2026-01-12'
      },
      onHoldAmount: {
        amount: 20000,
        releaseDate: '2026-04-12'
      },
      payOnCompletion: false
    },
    attachments: [
      {
        id: 'att4',
        fileName: 'Paving_Layout.pdf',
        fileType: 'PDF',
        fileUrl: '/documents/paving_layout_044.pdf',
        uploadDate: '2025-08-05'
      },
      {
        id: 'att5',
        fileName: 'Material_Specifications.pdf',
        fileType: 'PDF',
        fileUrl: '/documents/material_specs_044.pdf',
        uploadDate: '2025-08-05'
      }
    ],
    contractorActions: [
      {
        actionType: 'accept',
        timestamp: '2025-08-06T14:15:00Z',
        authorizedPersonName: 'David Kumar',
        digitalSignature: 'digital_signature_hash_xyz123'
      }
    ],
    lastContractorAction: 'Accepted',
    responseDate: '2025-08-06',
    slaAge: 0,
    remarks: '-'
  },
  {
    id: '4',
    woNumber: 'WO/2025-26/HYD/0045',
    title: 'HVAC Installation',
    description: 'Complete HVAC system installation for all floors including ducting, units, and controls',
    site: 'HYD/TWR-A',
    project: 'Hyderabad Tower Complex',
    organisation: 'CoolTech Systems',
    contractType: 'Time & Material',
    contractorName: 'CoolTech HVAC Solutions',
    status: 'Rejected',
    woValue: 3500000,
    dateReleased: '2025-08-04',
    plannedStartDate: '2025-09-01',
    plannedEndDate: '2025-12-31',
    contractDate: '2025-08-02',
    contractOwner: 'Lisa Chen',
    approvalsDone: ['Technical Approval'],
    linkedWorkRequest: 'WR/2025/HYD/004',
    workOrderLines: [
      {
        lineId: 'WOL-007',
        taskName: 'Ductwork Installation',
        workCategory: 'HVAC',
        quantity: 500,
        uom: 'Meters',
        rate: 2000,
        tax: 18,
        total: 1180000
      },
      {
        lineId: 'WOL-008',
        taskName: 'AC Unit Installation',
        workCategory: 'HVAC',
        quantity: 20,
        uom: 'Units',
        rate: 75000,
        tax: 18,
        total: 1770000
      }
    ],
    generalConditions: [
      'All equipment must be energy efficient',
      'Proper insulation required',
      'System testing and commissioning included'
    ],
    paymentConditions: {
      mobilizationAdvance: {
        percentage: 20,
        amount: 700000
      },
      retentionAmount: {
        percentage: 10,
        releaseDate: '2026-06-30'
      },
      onHoldAmount: {
        amount: 100000,
        releaseDate: '2026-12-31'
      },
      payOnCompletion: true
    },
    attachments: [
      {
        id: 'att6',
        fileName: 'HVAC_Layout.pdf',
        fileType: 'PDF',
        fileUrl: '/documents/hvac_layout_045.pdf',
        uploadDate: '2025-08-04'
      }
    ],
    contractorActions: [
      {
        actionType: 'reject',
        timestamp: '2025-08-05T16:45:00Z',
        authorizedPersonName: 'Amit Sharma',
        reason: 'Timeline too aggressive for current workload. Unable to commit to December completion.',
        comments: 'We would need at least 6 months from start date to complete this scope of work.'
      }
    ],
    lastContractorAction: 'Rejected',
    responseDate: '2025-08-05',
    slaAge: 2,
    remarks: 'Timeline concerns'
  },
];